export default function SsoFactory(deps, options = {}) {
  const { api, dataStore } = deps;
  const { apiHost } = options;

  return {
    getSsoUrl(returnTo) {
      const providerId = dataStore.get('pid');
      return api.post(`/provider/${providerId}/otp-token`)
        .then(({ otpToken }) => {
          return `${apiHost}/auth/sso/login?providerId=${providerId}&otpToken=${otpToken}&return_to=${returnTo}`;
        });
    },
  };
}
